import React from 'react';
import Programs from './Programs';

const TIPS = [
    {
        icon: 'icon-berry',
        title: 'Eat Healthy Food',
        text: 'How all this mistaken idea of denouncing pleasures and praising our work.',
    },
    {
        icon: 'icon-transport',
        title: 'Exercise Regularly',
        text: 'Complete account of system & expounds the actually master explorer.',
    },
    {
        icon: 'icon-food',
        title: 'Avoiding Bad Habits',
        text: 'Expounds the actual teaching that great explorer of there levelon builder won.',
    },
    {
        icon: 'icon-hand',
        title: 'Follow Good Hygiene',
        text: 'Denouncing pleasure praising pain born will completed of the system.',
    },
];

function Home() {
    return (<>
    <section className="main-slider main-slider-one">
        <div className="hero">
            <div className="container">
                <div className="hero-inner">
                    {/* Deliberately not using the template's .slide-content
                        class: responsive.css hides it outright below 768px,
                        a workaround for Revolution Slider captions. */}
                    <div className="hero-content">
                        <h1 className="big-title">NUTRISM</h1>
                        <p className="title">By Garima Rathore</p>
                    </div>
                    {/* Transparent cut-out of the studio portrait, so the
                        figure sits on the hero background rather than bringing
                        a grey rectangle with it. PNG fallback keeps the alpha. */}
                    <div className="hero-figure">
                        <picture>
                            <source
                                type="image/webp"
                                srcSet={`${process.env.PUBLIC_URL}/images/resources/hero-1100.webp 1100w, ${process.env.PUBLIC_URL}/images/resources/hero-1700.webp 1700w`}
                                sizes="(max-width: 767px) 88vw, 540px"
                            />
                            <img
                                src={`${process.env.PUBLIC_URL}/images/resources/hero-1100.png`}
                                srcSet={`${process.env.PUBLIC_URL}/images/resources/hero-1100.png 1100w, ${process.env.PUBLIC_URL}/images/resources/hero-1700.png 1700w`}
                                sizes="(max-width: 767px) 88vw, 540px"
                                alt="Garima Rathore"
                                width="1100"
                                height="892"
                            />
                        </picture>
                    </div>
                </div>
            </div>
        </div>
    </section>


    <section className="welcome-area">
        <div className="container">
            <div className="row align-items-center">

                <div className="col-12 col-lg-6">
                    <div className="welcome-image-holder">
                        <img src={`${process.env.PUBLIC_URL}/images/resources/nutrism-garima-rathore.png`} alt="Garima Rathore, clinical nutritionist"/>
                    </div>
                </div>

                <div className="col-12 col-lg-6">
                    <div className="text-holder">
                        <div className="sec-title">
                            <div className="title left">Nutrism By Garima Rathore</div>
                            <div className="dector thm-bg-clr"></div>
                        </div>
                        <div className="inner-content">
                            <div className="text">
                                <p>
                                Making sustainable lifestyle dietary changes seems straightforward but it can take a lot of patience and will power, especially in the early stages. Working closely with my clients, raising their awareness and helping them to understand the reasoning behind their customised program, helps with the adoption of beneficial practices that can be maintained. What we choose to consume can have a profound impact on our daily lives, health and longevity. At Nutrism, we believe that healthy eating is having a varied diet that meets your nutritional needs, taking into account your preferences, medical history, potential allergies and intolerances as well as some less obvious factors into consideration. Nutrism aims to offer safe and evidence based professional health service offering support, guidance and expertise to motivate clients in becoming the best expert in their own health. Nutrism not only supports a healthy way of eating for life but also an appetite to enjoy life to the full by reaping the benefits of optimum nutrition.
                                </p>
                            </div>
                        </div>
                    </div>

                </div>

            </div>
        </div>
    </section>


    <Programs></Programs>

    <section className="tips-area">
        <div className="container">
            <div className="sec-title text-center">
                <div className="title">Tips for Healthy Life</div>
                <div className="dector thm-bg-clr center"></div>
            </div>
            <div className="row">
                {TIPS.map((tip) => (
                    <div key={tip.title} className="col-12 col-sm-6 col-xl-3">
                        <div className="single-tips-item text-center">
                            <div className="icon-holder">
                                <span className={tip.icon}></span>
                            </div>
                            <div className="border-box"></div>
                            <div className="text-holder">
                                <h3>{tip.title}</h3>
                                <p>{tip.text}</p>
                            </div>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    </section>
    </>
    )
}

export default Home
